import {
  borderWidths,
  colors,
  gap,
  media,
  NewTypography as Typography,
  radius,
  spacing,
} from '@lamimed/pantheon';
import Image from 'next/image';
import styled, { css } from 'styled-components';

export const FileContent = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding-right: ${spacing.small};
  margin-right: ${spacing.small};
  border-right: ${borderWidths.thin} solid ${colors.neutral_light};

  ${gap(spacing.small)}
`;

export const FileIcon = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export const ThumbWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: ${radius.small};
  background-color: ${colors.neutral_light};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Thumb = styled(Image)`
  width: calc(4rem - (${borderWidths.small} * 2));
  height: calc(4rem - (${borderWidths.small} * 2));
  border-radius: calc(${radius.small} - 0.2rem);
  object-fit: cover;
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
`;

export const SmallTypography = styled(Typography)<{ isEllipsis?: boolean }>`
  && {
    font-size: 1rem;
    white-space: nowrap;

    ${({ isEllipsis }) =>
      isEllipsis &&
      css`
        text-overflow: ellipsis;
        overflow: hidden;
      `};

    ${media.greaterThan('tablet')`
      font-size: 1.4rem;
    `}
  }
`;

export const Wrapper = styled.div`
  width: 100%;

  cursor: pointer;
`;
